import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { supplierDetail } from '@/features/outlet/api'
import { SupplierFormUpdate } from '@/features/outlet/components/outlet-supplier-form'

export const Route = createFileRoute('/_app/inventory/supplier/$id/edit')({
	loader: async ({ context: { qc }, params: { id } }) => {
		await qc.ensureQueryData(supplierDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()
	const { supplier } = useSuspenseQuery(supplierDetail.qry({ id })).data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/supplier', 'Supplier'],
					['/inventory/supplier/$id/edit', supplier.name],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Buat supplier" />
				<SupplierFormUpdate />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
